import React from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import Home from "./home/HomeContainer";
import NewReport from './new-report/NewReportContainer';
import { AppRouters } from "application/globals/app-routers";
import { EmptyLayout, MainFull, MainLayout } from "./common/layout";
import PrivateRoute from "./common/route/PrivateRoute";
import AuthRoute from "./common/route/AuthRoute";
import ReportCheckout from "./report-checkout/ReportCheckout";
import { NavigatorContainer } from "./NavigatorContainer";
import { SignDocumentsPage } from "./sign-documents/sign-documents-container";
import { ProfilePage } from "presentation/user";
import { MyDocumentsPage } from "presentation/my-documents/my-documents";
import { SignInPage } from "presentation/user/sign-in/sign-in";
import { DocumentDetailPage } from "presentation/document-detail/document-detail";

export const Routes = (props) => {
  return (
    <Router>
      <div>
        <Switch>
          <Route path={AppRouters.withTicketSignDocuments} exact>
            <AuthRoute redirectTo={AppRouters.signDocuments} />
          </Route>

          <Route path={AppRouters.signIn} exact>
            <div className="viewport-container-fixed">
              <SignInPage />
            </div>
          </Route>

          <Route path={AppRouters.signDocuments}>
            <PrivateRoute
              enableGuestUser={false}
              component={SignDocumentsPage}
              layout={MainFull}
              title="DOCUMENTOS POR FIRMAR"
            />
          </Route>

          <Route path={AppRouters.documentDetail}>
            <PrivateRoute
              enableGuestUser={false}
              component={DocumentDetailPage}
              layout={MainFull}
              title="DETALLES SOLICITUD"
            />
          </Route>

          <Route path={AppRouters.newReport}>
            <PrivateRoute
              enableGuestUser={true}
              layout={MainLayout}
              component={NewReport}
              disabledWhatsapp
            />
          </Route>

          <Route path={AppRouters.auth}>
            <AuthRoute redirectTo={AppRouters.myDocs} />
          </Route>

          <Route path={AppRouters.confirmWizardReport}>
            <AuthRoute redirectTo={AppRouters.continueReportCheckout} />
          </Route>

          <Route path={AppRouters.myRequestWithError}>
            <PrivateRoute
              component={Home}
              layout={EmptyLayout}
              disabledWhatsapp
            />
          </Route>

          <Route path={AppRouters.continueReportCheckout}>
            <PrivateRoute
              enableGuestUser={false}
              component={ReportCheckout}
              layout={EmptyLayout}
              disabledWhatsapp
            />
          </Route>

          <Route path={AppRouters.satisfactoryPayment} exact>
            <PrivateRoute
              enableGuestUser={false}
              component={Home}
              layout={EmptyLayout}
              disabledWhatsapp
            />
          </Route>

          <Route path={AppRouters.home} exact>
            <PrivateRoute
              component={Home}
              layout={EmptyLayout}
            />
          </Route>

          <Route path={AppRouters.myProfile} exact>
            <PrivateRoute
              enableGuestUser={false}
              layout={MainLayout}
              component={ProfilePage}
              disabledWhatsapp
            />
          </Route>

          <Route path={AppRouters.myDocs} exact>
            <PrivateRoute
              enableGuestUser={false}
              layout={MainLayout}
              component={MyDocumentsPage}
            />
          </Route>

          <Route exact path="*">
            <Redirect to={AppRouters.home} />
          </Route>
        </Switch>
      </div>

      <NavigatorContainer />
    </Router>
  );
};

Routes.propTypes = {}

Routes.defaultProps = {}

export default Routes;
